// extracted by mini-css-extract-plugin
export default {"icon":"UserTagsContainer-icon-eb57a35275d87f54b3a0ac208f05ed23","tag":"UserTagsContainer-tag-0e0802e944d639d8f461c116c1321317"};